import { observable } from "mobx"
import { AddEmptyTriggerNodeToCanvas } from "components/Rappid/RappidCanvasFunctions";
import {
  applyNodeIdleStyle,
  applyNodeSelectedStyle,
} from "components/Rappid/nodes/campaignBuilder/nodeStyle";

const rappidStore = observable(
  {
    graph: undefined,
    tree: undefined,
    paper: undefined,
    node: undefined,
    paperScroller: undefined,
    navigator: undefined,
    activeElement: undefined,
    canvasJson: "",
    deletingNode: {},
    newElementViewModel: undefined,

    cleanRappid(resetToEmptyTrigger = true) {
      if (resetToEmptyTrigger) {
        this.graph && this.graph.clear();
        this.graph && AddEmptyTriggerNodeToCanvas(true);
      }
      this.graph = undefined;
      this.tree = undefined;
      this.paper = undefined;
      this.paperScroller = undefined;
      this.navigator && this.navigator.remove();
      this.navigator = undefined;
      this.activeElement = undefined;
      this.newElementViewModel = undefined;
      this.canvasJson = "";
    },

    setGraph(graph) {
      this.graph = graph;
    },

    setTree(tree) {
      this.tree = tree;
    },

    setPaper(paper) {
      this.paper = paper;
    },

    setNode(node) {
      this.node = node;
    },

    setPaperScroller(paperScroller) {
      this.paperScroller = paperScroller;
    },

    setNavigator(navigator) {
      this.navigator = navigator;
    },

    setActiveElement(activeElement) {
      this.activeElement && this.resetActiveElement();
      this.activeElement = activeElement;
      applyNodeSelectedStyle(this.activeElement);
    },

    resetActiveElement() {
      applyNodeIdleStyle(this.activeElement);
      this.activeElement = undefined;
    },

    setNewElementViewModel(newElementViewModel) {
      this.newElementViewModel = newElementViewModel;
    },

    resetNewElementViewModel() {
      this.newElementViewModel = undefined;
    },

    setCanvasJson(canvasJson) {
      this.canvasJson = canvasJson;
    },

    setDeletingNode(deletingNode) {
      this.deletingNode = deletingNode;
    }
  }
);

export default rappidStore;
